import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
/**
 * @function PromoLinkView 
 * @param {STRING} text Pass the text for the link.
 * @returns {React.Component}
 * @example
 * <div className="promo-container flex-container flex-horizontal align-center">
 *  <PromoInfoView icon={icon} title={title} description={description} />
 *  <PromoLinkView text="Some link" />
 * </div>
*/
export function PromoLinkView(props) {
    const text = props.text ?? "[[text]]";
    const dataPointLink = props.dataPoint ? { "data-point" :`${props.dataPoint}_Link` } : {};
    const dataPointChevron = props.dataPoint ? { "data-point" :`${props.dataPoint}_Chevron` } : {};
    
    return (
      <div className="promo-link-view set-width flex-container align-center clickable" onClick={ props.onClick }>
          <span {...dataPointLink}>{text}</span>
          <SVGAsset id="RightChevronIcon"  className="right-chevron-icon" { ...dataPointChevron } />
      </div>
    )
  }